
const eth_pub_to_std_pub = (pubkey: string) => `04${pubkey.substring(2)}`
export default eth_pub_to_std_pub